import { ArrowRight, X } from "lucide-react";
import Booklet from "../Home/Booklet";
import { useState, useEffect } from "react";
import ItemsForCatalogs from "../Home/ItemsForCatalogs";
import { useNavigate } from "react-router-dom";

function daysLeft(dateStr) {
  const today = new Date();
  const d = new Date(dateStr);
  const diff = Math.ceil((d - today) / (1000 * 60 * 60 * 24));
  if (diff < 0) return "Expired";
  if (diff === 0) return "Last day";
  if (diff === 1) return "1 day left";
  return `${diff} days left`;
}

export default function StoreCatalogModal({ catalog, onClose }) {
  const [activeTab, setActiveTab] = useState("booklet");
  const navigate = useNavigate();


  // lock background scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "");
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-white flex flex-col">
      {/* ================= HEADER ================= */}
      <header className="shrink-0 flex flex-row-reverse items-center justify-between px-5 py-3 border-b border-white/10">

        <button
          onClick={onClose}
          className="text-black/70 hover:text-black"
        >
          <X size={18} />
        </button>
      </header>
      {/* ================= TABS ================= */}
      <div className="shrink-0 px-5">
        <div className="flex gap-6">
          <button
            onClick={() => setActiveTab("booklet")}
            className={`py-3 text-sm ${
              activeTab === "booklet"
                ? "border-b-2 border-blue-500 text-blue-400 font-semibold"
                : "text-black/60 hover:text-black"
            }`}
          >
            Booklet
          </button>

          <button
            onClick={() => setActiveTab("items")}
            className={`py-3 text-sm ${
              activeTab === "items"
                ? "border-b-2 border-blue-500 text-blue-400 font-semibold"
                : "text-black/60 hover:text-black"
            }`}
          >
            Items
          </button>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="flex-1 overflow-hidden">
        {activeTab === "booklet" && (
          <div className="h-full">
            {/* Booklet should control its own scrolling/zoom */}
            <Booklet
              catalogueUrl={catalog.catalogueImageUrl}
            />
          </div>
        )}
        {activeTab === "items" && (
          <div className="h-full">
            {/* Items for Catalog */}  
            <ItemsForCatalogs offerHeaderId={catalog?.offerId || 147} /> 
          </div>
        )}
      </div>
      {/* ================= FOOTER ================= */}
      <footer className="shrink-0 border-t border-white/10 px-5 py-3 flex justify-end">
        <button
          type="button"
          className="inline-flex items-center gap-2 text-xs text-black/70 hover:text-black"
           onClick={() => navigate(`/${catalog.storeName}/catalog/${147}` , { state: catalog })}

        >
          <ArrowRight className="w-3.5 h-3.5" />
          Open full catalog in new tab
        </button>
      </footer>
    </div>
  );
}
